import { Variant } from '@/modules/models/Variant';

export interface LinkType {
  type: 'image' | 'text';
  url?: string | null;
  imageUrl?: string | null;
  title?: string | null;
  oldPrice?: string | null;
  price: string | null;
  countryCode: string;
  content?: string;
  handle: string;
  variants: Variant[];
  optionNames: (string | null)[] | null;
  reviewCount?: number;
  reviewScore?: number;
}
